// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"589797d5","757":"589797d5","886":"589797d5"}[chunkId] + ".chunk.css";
};